import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterContainerSectionControlValue = function (props) {
    var isSingle = props.isSingle, value = props.value, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-container-v2-section-control-value", { ref: ref, "is-single": [true, false].includes(isSingle) ? (isSingle ? 'true' : 'false') : undefined, value: value, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterContainerSectionControlValue;
